// extracted by mini-css-extract-plugin
module.exports = {"container":"submit_section_container__jaD7C"};